"use client";
function o(n = 21) {
  const e = new Uint8Array(n);
  return crypto.getRandomValues(e), Array.from(e, (t) => t.toString(36)).join("").slice(0, n);
}
const r = /* @__PURE__ */ new Map();
function u(n = "id") {
  const t = (r.get(n) || 0) + 1;
  return r.set(n, t), `${n}${t}`;
}
export {
  u as generatePrefixedUniqueId,
  o as generateUid
};
